var tag = document.createElement('script');
tag.id = 'iframe-demo';
tag.src = 'https://www.youtube.com/iframe_api';
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var player;

const videoPlayBtn = document.getElementById('video-play-btn');
const posterLayer = document.querySelector('.jumbotron-video-inner');
const prevBtn = document.querySelector('.carousel-control-prev');
const nextBtn = document.querySelector('.carousel-control-next');

if (videoPlayBtn) {

  function onYouTubeIframeAPIReady() {
    player = new YT.Player('carousel-iframe-video', {
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
    });

    videoPlayBtn.addEventListener('click', (e) => {
      posterLayer.classList.add('index-changed');
      player.playVideo();
    });

    [nextBtn, prevBtn].forEach((item) => {
      item.addEventListener('click', (element) => {
        if ( player.getPlayerState() == 1) {
          player.pauseVideo();
        }
      });
    });
  }

  function onPlayerReady(event) {
    console.log(event.data);
  }

  function onPlayerStateChange() {
    if ( player.getPlayerState() == 0) {
      posterLayer.classList.remove('index-changed');
    }
  }
}